export default __webpack_public_path__ + "images/36c7df24b38092f4632a6b53e10cff96.png";